var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-text",
            { staticClass: "p-0" },
            [
              _c("GChart", {
                attrs: {
                  type: _vm.chartType,
                  data: _vm.chartData,
                  options: _vm.chartOptions
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "rgb(64,79,191)",
                loading: _vm.loading,
                dark: "",
                block: "",
                title: "Seguimiento procesamiento"
              },
              on: {
                click: function($event) {
                  return _vm.abrirCerrarDialog()
                }
              }
            },
            [
              _c("v-icon", [_vm._v("timeline")]),
              _vm._v("\n      SEGUIMIENTO\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "1300" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.cargarSeguimientoTipificacion(_vm.form)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs9: "" } },
                        [
                          _c("v-icon", [_vm._v("timeline")]),
                          _vm._v(
                            " SEGUIMIENTO PROCESAMIENTO DE CONTROL DE\n            ASISTENCIA\n          "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.abrirCerrarDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha registro",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.fecha_registro,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_registro", $$v)
                                  },
                                  expression: "form.fecha_registro"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Nro documento",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.nro_doc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_doc", $$v)
                                  },
                                  expression: "form.nro_doc"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Nombres",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.nombres,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nombres", $$v)
                                  },
                                  expression: "form.nombres"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Ap paterno",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.ap_paterno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ap_paterno", $$v)
                                  },
                                  expression: "form.ap_paterno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Ap materno",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.ap_materno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ap_materno", $$v)
                                  },
                                  expression: "form.ap_materno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha inicio",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.fecha_inicio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_inicio", $$v)
                                  },
                                  expression: "form.fecha_inicio"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha fin",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.fecha_fin,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_fin", $$v)
                                  },
                                  expression: "form.fecha_fin"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md3: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    type: "submit",
                                    color: "rgb(64,79,191)",
                                    loading: _vm.loading,
                                    dark: "",
                                    title: "Buscar"
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("search")]),
                                  _vm._v(
                                    "\n                BUSCAR\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.l_seguimiento,
                                  "no-data-text": _vm.loading
                                    ? "Cargando..."
                                    : "No se tiene registros",
                                  loading: _vm.loading,
                                  "item-key": "index",
                                  "rows-per-page-text": "Filas por pagina",
                                  pagination: _vm.pagination,
                                  "rows-per-page-items": [
                                    5,
                                    10,
                                    20,
                                    50,
                                    { value: -1, text: "Todos" }
                                  ]
                                },
                                on: {
                                  "update:pagination": function($event) {
                                    _vm.pagination = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "headers",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "tr",
                                          _vm._l(props.headers, function(
                                            header
                                          ) {
                                            return _c(
                                              "th",
                                              {
                                                key: header.text,
                                                staticClass:
                                                  "header-comprimido",
                                                class: [
                                                  "column sortable",
                                                  _vm.pagination.descending
                                                    ? "desc"
                                                    : "asc",
                                                  header.value ===
                                                  _vm.pagination.sortBy
                                                    ? "active"
                                                    : ""
                                                ],
                                                attrs: { id: "cabecera_tabla" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.changeSort(
                                                      header.value
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                header.value
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "white"
                                                        }
                                                      },
                                                      [_vm._v("arrow_upward")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(header.text) +
                                                    "\n                    "
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-center py-0 px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.fecha_registro,
                                                      "YYYY-MM-DD HH:mm:ss"
                                                    )
                                                    .format(
                                                      "DD/MM/YYYY HH:mm:ss"
                                                    )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-center py-0 px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(props.item.nro_doc) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-center py-0 px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(props.item.ap_paterno) +
                                                " " +
                                                _vm._s(props.item.ap_materno) +
                                                "\n                    " +
                                                _vm._s(props.item.nombres) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-center py-0 px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.fecha_inicio
                                                    )
                                                    .format("DD/MM/YYYY")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-center py-0 px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.fecha_fin
                                                    )
                                                    .format("DD/MM/YYYY")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-center py-0 px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item
                                                        .fecha_inicio_proceso,
                                                      "YYYY-MM-DD HH:mm:ss"
                                                    )
                                                    .format(
                                                      "DD/MM/YYYY HH:mm:ss"
                                                    )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-center py-0 px-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item
                                                        .fecha_fin_proceso,
                                                      "YYYY-MM-DD HH:mm:ss"
                                                    )
                                                    .format(
                                                      "DD/MM/YYYY HH:mm:ss"
                                                    )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c90557ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c90557ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/pasantes/components/MonitoreoTipificacion.vue
// module id = null
// module chunks = 